import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.object.values";
// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var VENUE_DETAIL_PATH = '/studios';
export default (function () {
  return {
    path: VENUE_DETAIL_PATH,
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        var _require = require('constants/unlaunched-venues'),
            unlaunchedVenuesByCity = _require.unlaunchedVenuesByCity;

        callback(null, [{
          path: 'out-of-network',
          component: require('features/VenueDetail/Unlaunched/UnlaunchedVenueCities').UnlaunchedVenueCities
        }, {
          path: 'out-of-network/:city',
          getComponent: function getComponent(_ref, cb) {
            var city = _ref.params.city;
            var hasCity = unlaunchedVenuesByCity[city];
            cb(null, hasCity ? require('features/VenueDetail/Unlaunched/UnlaunchedVenuesList').UnlaunchedVenuesList : require('features/ErrorPages/NotFound').NotFound);
          }
        }, {
          path: ':venueAlias',
          getComponent: function getComponent(_ref2, cb) {
            var venueAlias = _ref2.params.venueAlias;
            var unlaunchedVenuesInCity = Object.values(unlaunchedVenuesByCity).find(function (venues) {
              return venues[venueAlias];
            });
            cb(null, unlaunchedVenuesInCity ? require('features/VenueDetail/Unlaunched/UnlaunchedVenueDetailContainer').UnlaunchedVenueDetailContainer : require('containers/VenueDetail/VenueDetailContainer').VenueDetailContainer);
          }
        }, {
          path: ':venueAlias/reviews',
          component: require('containers/VenueDetail/VenueReviews').VenueReviews
        }, {
          path: ':venueAlias/:classAlias/:scheduleId',
          onEnter: function onEnter(_ref3, replace, cb) {
            var params = _ref3.params;
            return cb(replace({
              pathname: "/classes/".concat(params.venueAlias, "/").concat(params.classAlias, "/").concat(params.scheduleId),
              state: {
                status: 301
              }
            }));
          }
        }]);
      }, 'venue-detail');
    }
  };
});